import "client-only"

import {
  CookieConsent,
  getOneTrustCookieConsent,
  OPTANON_CONSENT_COOKIE_NAME,
} from "@/lib/oneTrust"
import { useEffect, useState } from "react"

export function usePixelInjectionPermissionPsIta() {
  const APP_VENDOR =
    typeof window !== "undefined" ? window.APP_VENDOR : process.env.APP_VENDOR

  const generalPermission = usePixelInjectionPermission()

  return APP_VENDOR === "pokerstars" && generalPermission
}

export function usePixelInjectionPermissionSisal() {
  const APP_VENDOR =
    typeof window !== "undefined" ? window.APP_VENDOR : process.env.APP_VENDOR

  const generalPermission = usePixelInjectionPermission()

  return APP_VENDOR === "sisal" && generalPermission
}

export function usePixelInjectionPermissionSnai() {
  const APP_VENDOR =
    typeof window !== "undefined" ? window.APP_VENDOR : process.env.APP_VENDOR

  const generalPermission = usePixelInjectionPermission()

  return APP_VENDOR === "snai" && generalPermission
}

function usePixelInjectionPermission() {
  const calcPixelInjectionPermission = () => {
    return getOneTrustCookieConsent(CookieConsent.ProfilationTargeting)
  }

  const [canInjectPixels, setCanInjectPixels] = useState(
    calcPixelInjectionPermission,
  )

  useEffect(() => {
    const browserSupportsCookieStore = "cookieStore" in window
    if (!browserSupportsCookieStore) {
      return
    }

    const cookieStoreChangeCallback = (ev: CookieChangeEvent) => {
      const optanonConsentHaveChanged = ev.changed.some(
        (changedCookie) => changedCookie.name === OPTANON_CONSENT_COOKIE_NAME,
      )

      if (optanonConsentHaveChanged) {
        setCanInjectPixels(calcPixelInjectionPermission())
      }
    }

    cookieStore.addEventListener("change", cookieStoreChangeCallback)

    return () => {
      cookieStore.removeEventListener("change", cookieStoreChangeCallback)
    }
  }, [])

  return canInjectPixels
}
